import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import T from '@wojtekmaj/react-t';

import Button from '@rewardopl/react-ui/button';

import { post } from '@rewardopl/utils/network';

import {
  ButtonTabsWrapper,
  ButtonWrapper,
  ContentWrapper,
  Footer,
  Heading,
  Intro,
  List,
  ScrollContainer,
  Wrapper,
} from './index.styles';

import ButtonTabs from '../../../../../common/button_tabs';
import Items from './items';

import { likedVendorPlacesState, modeState, vendorPlacesQuery } from '../../../../../../store';

import type { PlaceWithDynamicPropertiesForUser } from '@rewardopl/types';

const tabs = [
  {
    label: 'BubbleJoy',
    value: 'bubblejoy',
  },
  {
    label: 'BubbleJoy Taiwan',
    value: 'bubblejoy_taiwan',
  },
] as const;

export default function SelectFavoritePlacePage() {
  const navigate = useNavigate();
  const likedPlaces = useAtomValue(likedVendorPlacesState);
  const setPlaces = useSetAtom(
    vendorPlacesQuery({
      includePlacesWithoutLocation: true,
    }),
  );
  const [mode, setMode] = useAtom(modeState);
  const [selectedPlaceId, setSelectedPlaceId] = useState<
    PlaceWithDynamicPropertiesForUser['_id'] | null
  >(null);

  const hasFavoritePlace = Boolean(likedPlaces.length);

  if (hasFavoritePlace) {
    return <Navigate to=".." />;
  }

  async function onAccept() {
    const action = `/api/places/${selectedPlaceId}/like`;

    const response = (await post(action)) as PlaceWithDynamicPropertiesForUser;

    setPlaces((prevPlaces) =>
      prevPlaces.map((place) => (place._id === selectedPlaceId ? response : place)),
    );

    navigate('..');
  }

  return (
    <Wrapper>
      <ScrollContainer>
        <ContentWrapper>
          <Heading>
            <T>Select your venue</T>
          </Heading>
          <Intro>
            <T>Select a venue and receive messages and offers personalized for your location.</T>
          </Intro>
          <ButtonTabsWrapper>
            <ButtonTabs onChange={setMode} tabs={tabs} value={mode} />
          </ButtonTabsWrapper>
          <List>
            <Items selectedPlaceId={selectedPlaceId} setSelectedPlaceId={setSelectedPlaceId} />
          </List>
        </ContentWrapper>
      </ScrollContainer>
      <Footer>
        <ButtonWrapper>
          <Button className="primary" disabled={!selectedPlaceId} onClick={onAccept} type="button">
            <T>Confirm</T>
          </Button>
        </ButtonWrapper>
      </Footer>
    </Wrapper>
  );
}
